export default function PHP_date_diff() {
  return (
    <div>
      <h1>PHP_date_diff</h1>
    </div>
  );
}
